export const fastTravelMarkers = [
  { id: "HERMITS_COTTAGE", name: "Hermit's Cottage", x: 202, y: 400 },
  { id: "DRUID_PADDOCK", name: "Druid Paddock", x: 246, y: 90 },
  { id: "DUNDULL", name: "Dundull", x: 390, y: 348 },
  { id: "SILVERGLADE_MANOR", name: "Silverglade Manor", x: 141, y: 178 },
  { id: "JASPERS_PUMPKIN_FARM", name: "Jasper's Pumpkin Farm", x: 118, y: 149 },
  { id: "STORMGARDEN", name: "Stormgarden", x: 87, y: 297 },
  { id: "SOUTH_HOOF_FARM", name: "South Hoof Farm", x: 264, y: 350 },
  { id: "SUNFIELD_FARM", name: "Sunfield Farm", x: 26, y: 237 },
  { id: "STEVES_FARM", name: "Steve's Farm", x: 204, y: 193 },
  { id: "FORT_PINTA", name: "Fort Pinta", x: 238, y: 266 },
  { id: "BIRKS_GRANGE", name: "Birk's Grange", x: 323, y: 258 },
  { id: "JARLAHEIM", name: "Jarlaheim", x: 41, y: 237 },
  { id: "VALEDALE_LAKE", name: "Valedale Lake", x: 318, y: 125 },
  { id: "SPYMASTERS_HIDEOUT", name: "Spymaster's hideout", x: 236, y: 78 },
  { id: "CRESCENT_MOON_VILLAGE", name: "Crescent Moon Village", x: 93, y: 330 },
  { id: "ICENGATE", name: "Icengate", x: 320, y: 10 },
  { id: "SILVERGLADE_VILLAGE", name: "Silverglade Village", x: 184, y: 199 },
  { id: "REDWOOD_POINT", name: "Redwood Point", x: 367, y: 250 },
  { id: "STARSHINE_RANCH", name: "Starshine Ranch", x: 302, y: 228 },
  { id: "MOORLAND_STABLES", name: "Moorland Stables", x: 188, y: 241 },
  {
    id: "NEW_HILLCREST_STABLES",
    name: "New Hillcrest Stables",
    x: 157,
    y: 348,
  },
  { id: "GOLDENLEAF_STABLES", name: "Goldenleaf Stables", x: 32, y: 90 },
  { id: "MARLEYS_VINTAGE_BARN", name: "Marley's Vintage Barn", x: 175, y: 179 },
  { id: "BARONESS_RACETRACK", name: "Baroness' Racetrack", x: 171, y: 133 },
  { id: "RIDING_ARENA", name: "Riding Arena", x: 118, y: 176 },
  { id: "FIRGROVE_VILLAGE", name: "Firgrove Village", x: 337, y: 175 },
  { id: "TAILTOP_VILLAGE", name: "Tailtop Village", x: 405, y: 197 },
  { id: "VALEDALE_VILLAGE", name: "Valedale Village", x: 272, y: 108 },
  { id: "PADDOCK_ISLAND", name: "Paddock Island", x: 22, y: 273 },
  { id: "NILMERS_HIGHLAND", name: "Nilmer's Highland", x: 151, y: 221 },
  {
    id: "CAPE_WEST_FISHING_VILLAGE",
    name: "Cape West Fishing Village",
    x: 42,
    y: 127,
  },
  { id: "WOLF_HALL_INN", name: "Wolf Hall Inn", x: 142, y: 253 },
  { id: "THE_FORGOTTEN_FIELDS", name: "The Forgotten Fields", x: 87, y: 207 },
  { id: "FORT_PINTA_BEACH", name: "Fort Pinta Beach", x: 244, y: 260 },
  { id: "MEDIEVAL_CAMP", name: "Medieval Camp", x: 89, y: 173 },
  {
    id: "NIC_STONEGROUNDS_CAMP",
    name: "Nic Stoneground's Camp",
    x: 308,
    y: 49,
  },
  { id: "THE_EVERWIND_FIELDS", name: "The Everwind Fields", x: 182, y: 161 },
];
